// import React, { useState } from 'react';

// const ServiceCard = ({ title, description, items, image }) => {
//   const [expanded, setExpanded] = useState(false);
  
//   return (
//     <div className="w-full bg-white rounded-lg shadow-md overflow-hidden mb-8">
//       <div className="flex flex-col md:flex-row">
//         <div className="p-6 md:p-8 md:w-2/3">
//           <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">{title}</h3>
//           <p className="text-gray-600 mb-4">{description}</p>
          
//           {items && items.length > 0 && (
//             <div className={`${expanded ? 'block' : 'hidden md:block'}`}>
//               <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-4">
//                 {items.map((item, index) => (
//                   <li key={index} className="flex items-start">
//                     <span className="text-blue-600 mr-2">•</span>
//                     <span>{item}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
          
//           {items && items.length > 0 && (
//             <button 
//               className="mt-4 text-blue-700 hover:text-blue-900 font-medium md:hidden"
//               onClick={() => setExpanded(!expanded)}
//             >
//               {expanded ? 'Show Less' : 'Show More'}
//             </button>
//           )}
//         </div>
        
//         {image && (
//           <div className="md:w-1/3 bg-gray-100 flex items-center justify-center p-4">
//             <img 
//               src={image || "/api/placeholder/300/200"} 
//               alt={title}
//               className="max-h-48 object-contain"
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const ServicesPage = () => {
  // const services = [
  //   {
  //     id: 1,
  //     title: "1. Cost Record Maintenance",
  //     description: "We provide the Guidance for Maintenance of Cost Accounting Records prescribed under the Companies (Cost Records and Audit) Rules 2014 and certification as regards maintenance of Cost Records by the company. Study of organizational systems & procedures, implementation of Costing system, analysis of Process / Product profitability etc. Review and implementation of Cost management process, decision support system and Management reporting framework.",
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 2,
  //     title: "2. Audit & Assurance Services",
  //     description: "Audits are all about Checks, Controls and assurance, which may be complied statutorily or even be held voluntarily by the entity to assure the true view of business in terms of finance. You can rely on us for end to end audits and assurance services.",
  //     items: ["Cost Audit", "Tax Audit", "Internal Audit", "Forensic Audit", "Statutory Audit", "Stock Audit", "Bank Audit"],
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 3,
  //     title: "3.1 Income Tax Services",
  //     description: "An income tax is a tax imposed on individuals or entities (taxpayers) in respect of the income or profits earned by them (commonly called taxable income). Income tax generally is computed as the product of a tax rate times the taxable income.",
  //     items: ["Corporate Taxation Advisory Services", "Tax Planning", "TDS / TCS Compliance", "Assessment Proceedings", "Tax Appeals", "Income Tax Compliance", "PAN & TAN Apply"],
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 4,
  //     title: "3.2 Goods and Service Tax",
  //     description: "Goods and Services Tax (GST) is an indirect tax (or consumption tax) used in India on the supply of goods and services. The GST was launched at midnight on 1 July 2017 by the President of India, and the Government of India.",
  //     items: ["Registration with various authorities", "Return filling and other Compliances", "Consultation for Day to Day GST compliances", "Advisory on Claims for Refunds", "Audit", "Maintenance of Records", "Filling of Appeal", "Handling GST Audit/Search/Survey"],
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 5,
  //     title: "4. Company Law Services",
  //     description: "Unlike a lot of CA firms, right from the inception of an entity to general corporate matters, guiding companies routinely on their business and legal issues to assisting and advising them in relation to complex transactions.",
  //     items: ["Formation of Various Entities i.e. Pvt Ltd, Public Ltd & LLP", "Filling of annual returns", "Conversion of Proprietary & Partnership into Company", "Dissolution of Company"],
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 6,
  //     title: "5. Accounting",
  //     description: "Accounting, also known as, accountancy, is the measurement, processing, and communication of financial and non financial information about economic entities such as businesses and corporations.",
  //     items: ["Day to Day Accounting", "Designing of System for better Compliances", "CMA Data Preparation"],
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 7,
  //     title: "6. Human Resources and Labour Law Services",
  //     description: "Labour laws (also known as labor laws or employment laws) are those that mediate the relationship between workers, employing entities, trade unions and the government. Collective labour law relates to the tripartite relationship between employee, employer and union.",
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 8,
  //     title: "7. Loans and Finances",
  //     description: "A term loan is the simplest form of corporate debt. It consists of an agreement to lend a fixed amount of money, called the principal sum or principal, for a fixed period of time, with this amount to be repaid by a certain date.",
  //     image: "/api/placeholder/300/200"
  //   },
  //   {
  //     id: 9,
  //     title: "8. Other Services Area",
  //     description: "Using the vast experience and expertise of the professionals of our Firm, we undertake professional services in any other related professional fields of Accounting, Cost and Management Accounting.",
  //     items: ["Import Export Certifications", "Due Diligence", "FSSAI Certificate", "TAN Certificate", "MSME Certificate", "Various Deed like. Partnership deed Gift Deed and HUF deed"],
  //     image: "/api/placeholder/300/200"
  //   }
  // ];

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <header className="bg-blue-700 text-white py-6">
//         <div className="container mx-auto px-4">
//           <div className="flex justify-between items-center">
//             <div className="text-2xl font-bold">CA Firm</div>
//             <nav className="hidden md:block">
//               <ul className="flex space-x-6">
//                 <li><a href="#" className="hover:text-blue-200">Home</a></li>
//                 <li><a href="#" className="hover:text-blue-200">About</a></li>
//                 <li><a href="#" className="font-bold border-b-2 border-white">Services</a></li>
//                 <li><a href="#" className="hover:text-blue-200">Contact</a></li>
//               </ul>
//             </nav>
//             <button className="md:hidden">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Hero Section */}
//       <div className="bg-blue-700 text-white py-12 md:py-24">
//         <div className="container mx-auto px-4">
//           <h1 className="text-4xl md:text-6xl font-bold mb-6">Our Services Offerings</h1>
//           <p className="text-xl md:w-2/3">
//             Comprehensive financial and business solutions to help your business grow and comply with regulatory requirements.
//           </p>
//         </div>
//       </div>

//       {/* Services Section */}
//       <div className="container mx-auto px-4 py-12 md:py-16">
//         <div className="max-w-4xl mx-auto">
//           {services.map((service) => (
//             <ServiceCard 
//               key={service.id}
//               title={service.title}
//               description={service.description}
//               items={service.items}
//               image={service.image}
//             />
//           ))}
//         </div>
//       </div>

//       {/* Call to Action */}
//       <div className="bg-gray-100 py-12">
//         <div className="container mx-auto px-4 text-center">
//           <h2 className="text-2xl md:text-3xl font-bold mb-4">Ready to get started?</h2>
//           <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
//             Our team of experts is ready to help you with your financial and compliance needs.
//           </p>
//           <button className="bg-blue-700 text-white py-3 px-8 rounded-lg font-medium hover:bg-blue-800 transition-colors">
//             Contact Us Today
//           </button>
//         </div>
//       </div>

//       {/* Footer */}
//       <footer className="bg-gray-800 text-white py-12">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <div>
//               <h3 className="text-xl font-bold mb-4">CA Firm</h3>
//               <p className="text-gray-400">
//                 Professional accounting, tax, and business advisory services for businesses and individuals.
//               </p>
//             </div>
//             <div>
//               <h3 className="text-xl font-bold mb-4">Quick Links</h3>
//               <ul className="space-y-2">
//                 <li><a href="#" className="text-gray-400 hover:text-white">Home</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-white">About Us</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-white">Services</a></li>
//                 <li><a href="#" className="text-gray-400 hover:text-white">Contact</a></li>
//               </ul>
//             </div>
//             <div>
//               <h3 className="text-xl font-bold mb-4">Contact Us</h3>
//               <address className="text-gray-400 not-italic">
//                 123 Finance Street<br />
//                 Mumbai, Maharashtra 400001<br />
//                 India<br /><br />
//                 <a href="tel:+919876543210" className="hover:text-white">+91 98765 43210</a><br />
//                 <a href="mailto:info@cafirm.com" className="hover:text-white">info@cafirm.com</a>
//               </address>
//             </div>
//           </div>
//           <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400">
//             <p>&copy; {new Date().getFullYear()} CA Firm. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default ServicesPage;

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import img1 from '../assets/1.jpg'
import img2 from '../assets/2.jpg'
import img3 from '../assets/3a.jpg'
import img4 from '../assets/4.jpg'
import img5 from '../assets/5.jpg'
import img6 from '../assets/6.jpg'
import img7 from '../assets/7.jpg'
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const ServiceCard = ({ title, description, items, image, index }) => {
  const [expanded, setExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="w-full bg-white rounded-xl shadow-lg overflow-hidden mb-8 hover:shadow-xl transition-shadow duration-300"
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      <div className="flex flex-col md:flex-row">
        <div className="p-8 md:w-2/3">
          <div className="flex items-center mb-6">
            <div className={`w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center mr-4 transition-colors duration-300 ${isHovered ? 'bg-customBlueDark' : ''}`}>
              <span className={`text-xl font-bold ${isHovered ? 'text-white' : 'text-customBlueLight'}`}>{index + 1}</span>
            </div>
            <h3 className="text-2xl font-bold text-gray-800">{title}</h3>
          </div>
          
          <p className="text-gray-600 mb-6 leading-relaxed">{description}</p>
          
          {items && items.length > 0 && (
            <div className={`${expanded ? 'block' : 'hidden md:block'}`}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                {items.map((item, idx) => (
                  <div key={idx} className="flex items-start p-3 bg-gray-50 rounded-lg hover:bg-blue-50 transition-colors">
                    <svg className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {items && items.length > 0 && (
            <button 
              className="mt-6 text-blue-600 hover:text-blue-800 font-medium flex items-center md:hidden"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? 'Show Less' : 'Show More'}
              <svg className={`w-4 h-4 ml-2 transition-transform ${expanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          )}
        </div>
        
        {image && (
          <div className="md:w-1/3 bg-white flex items-center justify-center relative">
            <div className="absolute inset-0 bg-white" />
            <img 
              src={image} 
              alt={title}
              className="h-full object-contain object-center transform hover:scale-105 transition-transform duration-300"
            />
          </div>
        )}
      </div>
    </motion.div>
  );
};

const ServicesPage = () => {
  const services = [
    {
      id: 1,
      title: "Cost Record Maintenance",
      description: "We provide the Guidance for Maintenance of Cost Accounting Records prescribed under the Companies (Cost Records and Audit) Rules 2014 and certification as regards maintenance of Cost Records by the company. Study of organizational systems & procedures, implementation of Costing system, analysis of Process / Product profitability etc. Review and implementation of Cost management process, decision support system and Management reporting framework.",
      image: img1
    },
    {
      id: 2,
      title: "Audit & Assurance Services",
      description: "Audits are all about Checks, Controls and assurance, which may be complied statutorily or even be held voluntarily by the entity to assure the true view of business in terms of finance. You can rely on us for end to end audits and assurance services.",
      items: ["Cost Audit", "Tax Audit", "Internal Audit", "Forensic Audit", "Statutory Audit", "Stock Audit", "Bank Audit"],
      image: img2
    },
    {
      id: 3,
      title: "Income Tax Services",
      description: "An income tax is a tax imposed on individuals or entities (taxpayers) in respect of the income or profits earned by them (commonly called taxable income). Income tax generally is computed as the product of a tax rate times the taxable income.",
      items: ["Corporate Taxation Advisory Services", "Tax Planning", "TDS / TCS Compliance", "Assessment Proceedings", "Tax Appeals", "Income Tax Compliance", "PAN & TAN Apply"],
      image: img3
    },
    {
      id: 4,
      title: "Goods and Service Tax",
      description: "Goods and Services Tax (GST) is an indirect tax (or consumption tax) used in India on the supply of goods and services. The GST was launched at midnight on 1 July 2017 by the President of India, and the Government of India.",
      items: ["Registration with various authorities", "Return filling and other Compliances", "Consultation for Day to Day GST compliances", "Advisory on Claims for Refunds", "Audit", "Maintenance of Records", "Filling of Appeal", "Handling GST Audit/Search/Survey"],
      image: img3
    },
    {
      id: 5,
      title: "Company Law Services",
      description: "Unlike a lot of CA firms, right from the inception of an entity to general corporate matters, guiding companies routinely on their business and legal issues to assisting and advising them in relation to complex transactions.",
      items: ["Formation of Various Entities i.e. Pvt Ltd, Public Ltd & LLP", "Filling of annual returns", "Conversion of Proprietary & Partnership into Company", "Dissolution of Company"],
      image: img4
    },
    {
      id: 6,
      title: "Accounting",
      description: "Accounting, also known as, accountancy, is the measurement, processing, and communication of financial and non financial information about economic entities such as businesses and corporations.",
      items: ["Day to Day Accounting", "Designing of System for better Compliances", "CMA Data Preparation"],
      image: img5
    },
    {
      id: 7,
      title: "Management Consultancy",
      description: "We provide comprehensive management consulting services to help organizations improve performance through analysis of existing organizational problems and development of improvement plans. Our services include strategic planning, operational efficiency improvement, organizational restructuring, and change management to align business operations with strategic goals.",
      items: [
        "Business Strategy Development",
        "Organizational Restructuring",
        "Process Optimization",
        "Change Management",
        "Performance Improvement",
        "Risk Management Advisory",
        "Digital Transformation Consulting"
      ],
      image: img6  // Assuming you have an appropriate image reference
    },
    {
      id: 8,
      title: "Other Services Area",
      description: "Using the vast experience and expertise of the professionals of our Firm, we undertake professional services in any other related professional fields of Accounting, Cost and Management Accounting.",
      items: ["Import Export Certifications", "Due Diligence", "FSSAI Certificate", "TAN Certificate", "MSME Certificate", "Various Deed like. Partnership deed Gift Deed and HUF deed"],
      image: img7
    }
  ];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Enhanced Header */}
      {/* <header className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex justify-between items-center h-16 lg:h-20">
            <div className={`text-2xl font-bold ${scrolled ? 'text-blue-700' : 'text-white'}`}>CA Firm</div>
            
            <nav className="hidden lg:block">
              <ul className="flex space-x-8">
                <li><a href="#" className={`hover:text-blue-600 ${scrolled ? 'text-gray-700' : 'text-white'}`}>Home</a></li>
                <li><a href="#" className={`hover:text-blue-600 ${scrolled ? 'text-gray-700' : 'text-white'}`}>About</a></li>
                <li><a href="#" className={`font-semibold border-b-2 ${scrolled ? 'border-blue-600 text-gray-700' : 'border-white text-white'}`}>Services</a></li>
                <li><a href="#" className={`hover:text-blue-600 ${scrolled ? 'text-gray-700' : 'text-white'}`}>Contact</a></li>
              </ul>
            </nav>
            
            <button 
              className="lg:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <svg className={`w-6 h-6 ${scrolled ? 'text-gray-700' : 'text-white'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </header> */}
      <Header />

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={() => setIsMenuOpen(false)}>
          <div className="absolute right-0 top-16 w-64 bg-white h-full p-4 shadow-lg">
            <nav>
              <ul className="space-y-4">
                <li><a href="#" className="block p-2 hover:bg-blue-50 rounded-lg">Home</a></li>
                <li><a href="#" className="block p-2 hover:bg-blue-50 rounded-lg">About</a></li>
                <li><a href="#" className="block p-2 bg-blue-50 rounded-lg font-semibold">Services</a></li>
                <li><a href="#" className="block p-2 hover:bg-blue-50 rounded-lg">Contact</a></li>
              </ul>
            </nav>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <div className="relative pt-32 pb-24 md:py-48 bg-gradient-to-r from-customBlueDark to-customBlueLight">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight"
          >
            Transformative Financial Solutions
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-blue-100 max-w-3xl mx-auto"
          >
            Empowering businesses with strategic financial expertise and regulatory compliance excellence.
          </motion.p>
        </div>
      </div>

      {/* Services Section */}
      <div className="container mx-auto px-4 lg:px-8 py-16 md:py-24">
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="grid gap-12 max-w-6xl mx-auto"
        >
          {services.map((service, index) => (
            <ServiceCard 
              key={service.id}
              index={index}
              {...service}
            />
          ))}
        </motion.div>
      </div>

      {/* Enhanced CTA */}
      <div className="relative bg-customBlueLight py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-700 to-blue-600" />
        </div>
        <div className="container mx-auto px-4 lg:px-8 text-center relative">
          <motion.div 
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            className="max-w-3xl mx-auto"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Let's Elevate Your Financial Strategy
            </h2>
            <p className="text-blue-100 text-lg mb-8">
              Schedule a consultation with our experts to discover tailored solutions for your business.
            </p>
            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-customBlueDark py-4 px-12 rounded-xl font-semibold hover:bg-blue-50 transition-colors shadow-lg"
            >
              <Link to="/contact" className="block w-full h-full">Schedule Consultation</Link>
            </motion.button>
          </motion.div>
        </div>
      </div>

      {/* Modern Footer */}
      <Footer/>
    </div>
  );
};

export default ServicesPage;